/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_TeamsInputs */

const th_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีม`)
};

const en_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ja_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム`)
};

const zh_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球队`)
};

const es_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipos`)
};

const pt_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Times`)
};

const id_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim`)
};

const fr_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipes`)
};

const tl_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga team`)
};

const vi_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội`)
};

const ko_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀`)
};

const de_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ru_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команды`)
};

const tr_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takımlar`)
};

const it_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadre`)
};

const pl_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drużyny`)
};

const uk_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команди`)
};

const hi_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीमें`)
};

const ar_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفرق`)
};

const ms_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan`)
};

const bn_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল`)
};

const zh_tw2_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const zh_hk2_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const ur_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیمیں`)
};

const fa_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیم‌ها`)
};

const sw_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu`)
};

const nl_tab_teams = /** @type {(inputs: Tab_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

/**
* | output |
* | --- |
* | "Teams" |
*
* @param {Tab_TeamsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_teams = /** @type {((inputs?: Tab_TeamsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_TeamsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_teams(inputs)
	if (locale === "ja") return ja_tab_teams(inputs)
	if (locale === "zh") return zh_tab_teams(inputs)
	if (locale === "es") return es_tab_teams(inputs)
	if (locale === "pt") return pt_tab_teams(inputs)
	if (locale === "id") return id_tab_teams(inputs)
	if (locale === "fr") return fr_tab_teams(inputs)
	if (locale === "tl") return tl_tab_teams(inputs)
	if (locale === "vi") return vi_tab_teams(inputs)
	if (locale === "ko") return ko_tab_teams(inputs)
	if (locale === "de") return de_tab_teams(inputs)
	if (locale === "ru") return ru_tab_teams(inputs)
	if (locale === "tr") return tr_tab_teams(inputs)
	if (locale === "it") return it_tab_teams(inputs)
	if (locale === "pl") return pl_tab_teams(inputs)
	if (locale === "uk") return uk_tab_teams(inputs)
	if (locale === "hi") return hi_tab_teams(inputs)
	if (locale === "ar") return ar_tab_teams(inputs)
	if (locale === "ms") return ms_tab_teams(inputs)
	if (locale === "bn") return bn_tab_teams(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_teams(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_teams(inputs)
	if (locale === "ur") return ur_tab_teams(inputs)
	if (locale === "fa") return fa_tab_teams(inputs)
	if (locale === "sw") return sw_tab_teams(inputs)
	if (locale === "nl") return nl_tab_teams(inputs)
	return en_tab_teams(inputs)
});